'use strict';

const functions = require('./fitAnalyticsFunctions');

var context = window.fitAnalyticsContext;
var fitAnalyticsData = window.fitAnalyticsData;

/* Add properties */
fitAnalyticsData.consent = { hasAnalyticsConsent() { return functions.getCookieConsents() } };
if (fitAnalyticsData && context == 'pdp') {
    fitAnalyticsData.operations = {
        getAddToCartBtn: function () { return document.querySelector('.add-to-cart') },
        getSizeChartLink: function () { return document.querySelector('.btn-sizeguide') },
        addToCart: function (currentItemSubgroupId, size) { return functions.addToCart(currentItemSubgroupId, size) },
        selectSize: function (currentItemSubgroupId, size) { return functions.selectSize(currentItemSubgroupId, size) },
        getCartItems: function () { return functions.getCartItems() }
    }
}